import React, { Component } from 'react';

import { Button } from 'reactstrap';
import background from '../../images/background.svg';
import logo from '../../images/logo.svg';
import authStore from '../../../stores/auth-store';
import swal from 'sweetalert';

class ResetPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            vefCode: null,
            password: '',
            Invalid: false,
            email: null,
            userId: null,
        };
        this.authEvents = [
            { name: authStore.getEventPrefix('resetPassword'), func: this.resetHandler }
        ];
    }
    componentDidMount() {
        let email= localStorage.getItem("forgot-email");
        if (email) {
            this.setState({
                email,
            })
        }
        else {
            console.log("ERR: email is not found")
        }

        this.authEvents.forEach((evnt) => authStore.on(evnt.name, evnt.func))
    }
    componentWillUnmount = () => {
        this.authEvents.forEach((evnt) => authStore.removeListener(evnt.name, evnt.func));
    }

    handlePasswordChange = (e) => {
        this.setState({
            password: e.target.value
        })
    }
    handleVefCodeChange= (e)=>{
        this.setState({
            vefCode: e.target.value,
        })
    }
    resetHandler = (e) => {
        console.log("email is sent successful")
    }
    handleSubmit = (e) => {
        e.preventDefault();

        let {email, password,vefCode } = this.state;

        if (email && password && vefCode) {
            authStore.resetPassword({ email,vefCode,password, })
                .then(({data}) => {
                    console.log(data);
                    if (data.success) {
                        swal({
                            title: "Success",
                            text: "Password Reset successfully. Please login.",
                            icon: "success",
                            dangerMode: false,
                        })
                        localStorage.removeItem("forgot-email");
                        this.props.history.push('/login')
                    }
                    else {
                        throw new Error(data.error)
                    }
                }).catch(err => {
                    swal({
                        title: "Error",
                        text: err.message,
                        dangerMode: true,
                    })
                    console.log("ERR: ",err.message);
                })
        }
        else {
            if(!email){
                this.setState({Invalid: 'Please send email again.'})
            }
            else{
            this.setState({ Invalid: 'Please fill all fields properly' });
            }
            setTimeout(() => {
                this.setState({ Invalid: false });
            }, 4000);
        }
    }

    render() {
        let { Invalid } = this.state;
        return (
            <div className="row" style={{ backgroundImage: `url(${background})`, minHeight: '100vh', backgroundSize: 'cover', width: '100%', margin: '0px', overflow: 'hidden' }}>
                <div className="col-md-12">
                    <div className="Login">
                        <form onSubmit={this.handleSubmit}>
                            <img src={logo} alt="logo" />
                            {
                                Invalid ?
                                    <label style={{ color: 'red', marginBottom: '12px' }}>{Invalid}</label>
                                    : ''
                            }
                            <div className="input-container">
                                <i className="fa fa-ticket icon"></i>
                                <input className="input-field" type="number" placeholder="Enter Verification Code"
                                    id="vp-code"
                                    value={this.state.vefCode}
                                    onChange={this.handleVefCodeChange}
                                    required
                                    type="number" />
                            </div>
                            <div className="input-container">
                                <i className="fa fa-key icon"></i>
                                <input className="input-field" type="password" placeholder="Enter Password"
                                    id="password"
                                    value={this.state.password}
                                    onChange={this.handlePasswordChange}
                                    required
                                    type="password" />
                            </div>
                            <Button
                                block
                                bsSize="large"
                                type="submit"
                                className="lightBlueButton btn btn-lg btn-default btn-block"
                            >
                                Reset Password
                        </Button>
                            <div onClick={() => this.props.history.push('/login')} className="textRightLink">
                                Back
                        </div>
                        </form>
                    </div>
                </div>
            </div>
        )
    }
}

export default ResetPassword;
